import React from 'react';

/* Siglas: se marcan como <abbr> para lectores de pantalla y buscadores. */
const ACRONYMS = /\b(IA|CRM|ERP|RGPD|API|APIs|PDF|SEO|GDPR|AI)\b/g;

export function T({ children }) {
  if (typeof children !== 'string') return children;
  const parts = children.split(ACRONYMS);
  return parts.map((p, i) => (i % 2 ? <abbr key={i} className="sc">{p}</abbr> : p));
}

/* Millares con punto a partir de cinco cifras (16.560), como se escribe en España */
export function num(n) {
  const s = String(Math.round(n));
  return s.length >= 5 ? s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : s;
}

export const euro = (n) => `${num(n)} €`;
